import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { PiCaretRight, PiChatTeardropDotsFill } from 'react-icons/pi';
import './styles.css';

const NaraContextEntry = ({ source }) => (
  <Link className="nara-context-entry" to={`/dashboard?assistant=1&source=${encodeURIComponent(source)}`}>
    <span className="nara-context-entry__icon" aria-hidden="true"><PiChatTeardropDotsFill /></span>
    <span>Perguntar à Nara</span>
    <PiCaretRight aria-hidden="true" />
  </Link>
);

NaraContextEntry.propTypes = { source: PropTypes.string.isRequired };
export default NaraContextEntry;
